/**
 * Sentry Error Tracking - Initialize BEFORE other imports
 * @see https://docs.sentry.io/platforms/javascript/guides/react/
 */

import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
    sendDefaultPii: false,
    debug: process.env.NODE_ENV !== "production",
    integrations: [
      Sentry.browserTracingIntegration({
        // Don't instrument fetch to avoid "body stream already read" errors
        traceFetch: false,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // Filter out errors from browser extensions or ad blockers
      if (event.exception) {
        const error = hint.originalException;
        if (
          error &&
          error.message &&
          (error.message.includes("extension") ||
            error.message.includes("ResizeObserver") ||
            error.message.includes("Script error"))
        ) {
          return null;
        }
      }
      return event;
    },
  });
  console.log("✅ Sentry error tracking initialized");
} else {
  console.log("⚠️ SENTRY_DSN not configured - error tracking disabled");
}

export default Sentry;
